import React, { useRef } from 'react'
import styles from './ShadowBox.module.css'
import truckPic from 'assets/svg/truck.svg'
import { getResizedPhotoUrl } from 'app/utils/photos'

import { useInView } from 'react-intersection-observer'

export default function ShadowBox(props) {
  const {
    caterer,
    city,
    photo,
    placeholder
  } = props

  const [ref, inView] = useInView({
    rootMargin: '10px 0px 10px 0px',
    threshold: 0.1,
    triggerOnce: true
  })

  return (
    <div
      ref={ref}
      className={[
        styles.box,
      ]}
      style={{
        backgroundImage: inView
          ? `url(${photo ? getResizedPhotoUrl(photo, 500, 500) : truckPic })`
          : placeholder ? `url(${placeholder})` : undefined
      }}
    >
      <a
        href={`/${caterer.slug}/`}
        className={styles.cover}
      >
        <h4>{caterer.name}</h4>
        {city && (
          <div className={styles.city}>
            {city.name}
          </div>
        )}
      </a>
    </div>
  )
}
